import React, { createContext, useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AccountTutorialContext = createContext();

export const AccountTutorialProvider = ({ children }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [runTutorial, setRunTutorial] = useState(true);
  const navigate = useNavigate();


  const handleNextStep = () => {
    setCurrentStep((prevStep) => {
      console.log("Updating step from", prevStep, "to", prevStep + 1);
      return prevStep + 1; // ✅ Correct state update
    });
  };
  
  
   useEffect(() => {
      console.log("Updated step in context:", currentStep);
    }, [currentStep]);

  return (
    <AccountTutorialContext.Provider value={{ currentStep, runTutorial, handleNextStep }}>
      {children}
    </AccountTutorialContext.Provider>
  );
};

export const useTutorial = () => useContext(AccountTutorialContext);
